import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminInvoicesPage from "@/pages/admin/AdminInvoicesPage";

export const Route = createFileRoute("/_admin/admin/invoices")({
  head: () => pageHead("Admin · Invoices", "AKIVA admin · invoices portal.", "/admin/invoices", true),
  component: AdminInvoicesPage,
});
